import React from "react";
import {
  List,
  Datagrid,
  TextField,
  Pagination,
  Filter,
  TextInput,
  BulkActionsToolbar,
  BulkDeleteButton,
} from "react-admin";
import { getPageId } from "../../helpers/getPageId";
import { useIsEnterprisePlan } from "../../helpers/subscriptionPlan";
import CustomDateField from "../Common/CustomDateField";
import CustomPickerInput from "../OrderItem/CustomPickerInput";

import ListActions from "./ListActions";

const DefaultFilters = (props) => (
  <Filter {...props}>
    <TextInput
      label="Label"
      source="label_contains"
      alwaysOn
      //parse={(v) => v.toUpperCase()}
    />
    <TextInput label="Description" source="description_contains" alwaysOn />
    <CustomPickerInput source="createdAt_gte" label="CreatedAt start" />
    <CustomPickerInput source="createdAt_lte" label="CreatedAt end" />
    <CustomPickerInput source="updatedAt_gte" label="UpdatedAt start" />
    <CustomPickerInput source="updatedAt_lte" label="UpdatedAt end" />
  </Filter>
);
const BulkActionButtons = () => {
  return (
    <BulkActionsToolbar selectAllButton={false}>
      <BulkDeleteButton />
    </BulkActionsToolbar>
  );
};

const TagList = (props) => {
  const pageId = getPageId();
  const isEnterprise = useIsEnterprisePlan();
  return (
    <List
      {...props}
      bulkActionsToolbar={<BulkActionButtons />}
      actions={<ListActions />}
      //exporter={exporter}
      filter={{ page: pageId }}
      filters={<DefaultFilters />}
      pagination={<Pagination rowsPerPageOptions={[10, 25, 50, 100]} />}
      sort={{ field: "createdAt", order: "DESC" }}
    >
      <Datagrid rowClick="show">
        <TextField source="label" />
        <TextField source="description" />
        <CustomDateField source="createdAt" showTime />
        <CustomDateField source="updatedAt" showTime />
      </Datagrid>
    </List>
  );
};

export default TagList;
